import { useTheme } from '@approvalmax/theme';
import { useSetAtom } from 'jotai';
import { FC, useEffect } from 'react';
import { useMedia } from 'react-use';

import { AmLogo } from '../../logos';
import { Grid } from '../Grid/Grid';
import { Content, Footer, LeftSide, RightSide, Top } from './components';
import { sizeSimpleLayoutState } from './SimpleLayout.states';
import { ContainerStyled, Root, Wrapper } from './SimpleLayout.styles';
import { ChildrenComponents, SimpleLayoutProps } from './SimpleLayout.types';

/**
 * SimpleLayout component allows creating a simple layout with a logo in the center and content in the middle.
 */
export const SimpleLayout: FC<SimpleLayoutProps> & ChildrenComponents = (props) => {
    const { size, verticalAlign = 'center', children, logo, ...restProps } = props;

    const { theme } = useTheme();
    const xsmallViewport = useMedia(`(max-width: ${theme.container.breakpoint.xsmall})`);
    const setSize = useSetAtom(sizeSimpleLayoutState);

    useEffect(() => {
        setSize(size);
    }, [setSize, size]);

    return (
        <Root {...restProps} $size={size}>
            <ContainerStyled>
                <Wrapper $size={size} $verticalAlign={verticalAlign}>
                    <Grid gridArea='logo' justifyContent='center' padding={`0 0 ${xsmallViewport ? '16' : '24'} 0`}>
                        {logo || <AmLogo width={161} height={24} />}
                    </Grid>

                    {children}
                </Wrapper>
            </ContainerStyled>
        </Root>
    );
};

SimpleLayout.displayName = 'SimpleLayout';

SimpleLayout.Content = Content;
SimpleLayout.LeftSide = LeftSide;
SimpleLayout.RightSide = RightSide;
SimpleLayout.Footer = Footer;
SimpleLayout.Top = Top;
